
const initialState = {
  token: sessionStorage.getItem('token'),
  authenticated: false,
  operatorId: sessionStorage.getItem('operatorId')
};

function session(state=initialState, action) {
  switch(action.type) {
    case 'AUTHENTICATE':
      return {
        ...state,
        authenticated: true,
        token: action.payload.token
      };

    case 'SET_OPERATOR':
      return {
        ...state,
        operatorId: action.payload.operatorId
      };
    case 'VERIFIED_TOKEN':
      return {
        ...state,
        authenticated: true
      };
    default:
      return state;
    }
}

export default session;



// WEBPACK FOOTER //
// ./src/reducers/session.js